// extracted by mini-css-extract-plugin
export var background = "cloud-native-platform-module--background--e6e85";
export var bgCssStyle = "cloud-native-platform-module--bg-css-style--542ca";
export var diagram = "cloud-native-platform-module--diagram--5858e";
export var dot = "cloud-native-platform-module--dot--f1fe2";
export var moreAbouts = "cloud-native-platform-module--more-abouts--be2b4";
export var products = "cloud-native-platform-module--products--0a4f1";
export var promo = "cloud-native-platform-module--promo--335f0";
export var promoContent = "cloud-native-platform-module--promoContent--fbe84";
export var reachBodyStyle = "cloud-native-platform-module--reach-body-style--ae148";